import React from 'react';
import { Grid } from '@material-ui/core';
import logo from './image/logo_educat.png'
import nameLogo from './image/name_educat.png'
import banner from './image/banner.svg'

function RectangleWithImagesAndText() {
  return (
    <img src={banner} alt="Banner" style={styles.image} />
  );
}

export default RectangleWithImagesAndText;

const styles = {
  image: {
    width: '100%',
    height: 'auto',
  }
};
